var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:"videoPlayer",attrs:{"src":_vm.videoUrl,"width":"1200","controls":"","autoplay":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }